import {
    V3ContentItemPublicPageLayoutContainer,
    getServerSidePropsWithContentItem
} from "../../../../../../pagelayouts/content-details/ContentDetailsPublicPageLayoutContainer";

export default function ContentItemSmartShareStandalonePublicPage() {
    return (
        <V3ContentItemPublicPageLayoutContainer
            isStandaloneCollectionView={false}
            isStandaloneContentItemView={false}
            useProfileSmartShareEndpoint={true}
            useArticleSmartShareEndpoint={false}
        />
    );
}

export const getServerSideProps = getServerSidePropsWithContentItem(true, true, false);
